"use strict";

angular.module("customer")
.controller("ReturnedQuantityModalController", function($scope, $attrs, close, CartItemService) {
    const DEFAULT_MAXIMUM_QUANTITY = 100;
    var defaultAvailableQuantities = [];

    $scope.quantityChoiceCount = DEFAULT_MAXIMUM_QUANTITY;
    $scope.packagingQuantity = $attrs.packagingQuantity || 1;

    for (var i = 0; i <= $scope.quantityChoiceCount * $scope.packagingQuantity; i+=$scope.packagingQuantity) {
        defaultAvailableQuantities.push(i);
    }

    $scope.vendor = $attrs.vendor;
    $scope.originalQuantity = $attrs.originalQuantity;
    $scope.customValue = $scope.originalQuantity;

    $scope.quantities = Array.isArray($attrs.availableQuantities) ? $attrs.availableQuantities : defaultAvailableQuantities;
    $scope.suggestedOrderMultiplier = $attrs.suggestedOrderMultiplier;

    this.isProductQuantityPatternValid = function() {
        return CartItemService.isProductQuantityPatternValid($scope.customValue);
    };

    this.getProductQuantityPatternError = function() {
        return CartItemService.getProductQuantityPatternError();
    };

    this.close = function() {
        $scope.$element.modal("hide");
        $scope.$element.remove();
        close.apply(this, arguments);
    };

    this.cancel = function() {
        this.close($scope.originalQuantity);
    };

    this.setQuantity = function(quantity) {
        $scope.returnedQuantityModalForm.$setSubmitted();
        $scope.quantity = quantity;
        $scope.customValue = $scope.quantity;

        $scope.returnedQuantityModalForm.quantityModal.$setValidity("quantityPattern", this.isProductQuantityPatternValid());

        if ($scope.returnedQuantityModalForm.quantityModal.$invalid) {
            angular.element("#modal-quantity").focus();
            return;
        }

        this.close($scope.quantity);
    };
});



//////////////////
// WEBPACK FOOTER
// ./customer/app-core/ordered-quantity/modals/returned-quantity.modal.js
// module id = 801
// module chunks = 0